export default __webpack_public_path__ + "static/media/019-youtube.5213846a.svg";